/* Monsuri — custom GA4 event tracking (front-of-funnel engagement).
 *
 * Fills the gaps Elevar's ecommerce data layer does NOT cover: mega-nav
 * engagement, the Build-a-Gift-Set promo funnel, and gift-builder interactions.
 *
 * Delivery: the storefront loads GA4 DIRECTLY via gtag.js (id below) — the
 * GTM-TPTGMCR container is only present as a <noscript> fallback and its gtm.js
 * never executes, so a dataLayer.push alone would go nowhere. We therefore send
 * each event straight to the live GA4 tag with gtag('event', …, { send_to }).
 * (Verified live 2026-06-09: gtag events land in property 308962333 / Realtime.)
 * If gtag is ever absent but a GTM container is restored, we fall back to a
 * dataLayer.push so the event still routes — either/or, so it never double-fires.
 * See Documentation/GA4_MEASUREMENT_PLAN.md.
 *
 * It does NOT emit ecommerce events (view_item / add_to_cart / purchase) — Elevar
 * owns those; duplicating them would double-count. Pure additive engagement layer.
 */
(function () {
  'use strict';

  // Public GA4 measurement ID for monsuri.com (not a secret — exposed in page
  // source as gtag/js?id=G-04VG181C0C). Scopes our events to the right property.
  var GA4_MEASUREMENT_ID = 'G-04VG181C0C';

  function track(event, params) {
    try {
      if (typeof window.gtag === 'function') {
        var p = { send_to: GA4_MEASUREMENT_ID };
        if (params) {
          for (var k in params) {
            if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k];
          }
        }
        window.gtag('event', event, p);
        return;
      }
      // Fallback: no gtag on the page → push for a GTM container to consume.
      window.dataLayer = window.dataLayer || [];
      var payload = { event: event };
      if (params) {
        for (var j in params) {
          if (Object.prototype.hasOwnProperty.call(params, j)) payload[j] = params[j];
        }
      }
      window.dataLayer.push(payload);
    } catch (e) { /* never break the page for analytics */ }
  }

  function txt(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  }
  function isMobile() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 900px)').matches);
  }
  function templateName() {
    return (window.Shopify && window.Shopify.template) || document.documentElement.getAttribute('data-template') || '';
  }

  // Capture phase so the event is pushed before any navigation/unload.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // 1) NAV engagement — any link inside the desktop/mobile nav (tier-1 + sub-links)
    var link = t.closest('a[href]');
    var navScope = link && link.closest('.main-nav, .nav-mobile, .nav-desktop, [data-meganav-desktop], [data-meganav-mobile]');
    if (link && navScope) {
      var handleEl = link.closest('[data-meganav-handle]');
      var isTier1 = link.classList.contains('nav-desktop__tier-1-link') || link.classList.contains('nav-mobile__tier-1-link');
      // v4 mega-menu context (ported from meganav.js bindAnalytics, which we remove to
      // avoid a duplicate click path): element type, panel layout, panel handle, position.
      var trackEl = link.closest('[data-mn-track]');
      var layoutEl = link.closest('[data-mn-layout]');
      var panelEl = link.closest('[data-meganav-handle]') || link.closest('[data-mn-panel-target]') || link.closest('[data-mn-tier1]');
      var navPos = 0;
      if (link.parentElement) {
        var sibs = link.parentElement.children;
        for (var si = 0; si < sibs.length; si++) { if (sibs[si] === link) { navPos = si + 1; break; } }
      }
      track('mega_nav_click', {
        nav_item: txt(link) || link.getAttribute('aria-label') || '',
        nav_url: link.getAttribute('href') || '',
        nav_tier: isTier1 ? 1 : 2,
        nav_handle: handleEl ? handleEl.getAttribute('data-meganav-handle') : '',
        nav_device: isMobile() ? 'mobile' : 'desktop',
        nav_element_type: trackEl ? trackEl.getAttribute('data-mn-track') : (isTier1 ? 'tier1' : 'tier2'),
        nav_layout: layoutEl ? layoutEl.getAttribute('data-mn-layout') : 'dropdown',
        nav_panel_handle: panelEl ? (panelEl.getAttribute('data-meganav-handle') || panelEl.getAttribute('data-mn-panel-target') || panelEl.getAttribute('data-mn-tier1') || '') : '',
        nav_position: navPos
      });
      return;
    }

    // 2) Build-a-Gift-Set promo CTA — the funnel into the builder
    var promo = t.closest('.gsbp__btn');
    if (promo) {
      var section = promo.closest('.gsbp--a, .gsbp--b, .gsbp--c');
      var variant = '';
      if (section) {
        variant = section.classList.contains('gsbp--a') ? 'band'
          : section.classList.contains('gsbp--b') ? 'card' : 'strip';
      }
      track('gift_set_promo_click', {
        cta_text: txt(promo),
        promo_variant: variant,
        page_type: templateName()
      });
      return;
    }

    // 3) Gift-builder interactions (the AOV engine)
    var add = t.closest('[data-gsb-add]');
    if (add) {
      var card = add.closest('[data-gsb-id]');
      track('gift_builder_add', {
        product_id: card ? card.getAttribute('data-gsb-id') : '',
        product_handle: card ? card.getAttribute('data-gsb-handle') : ''
      });
      return;
    }
    var occ = t.closest('[data-gsb-occasion]');
    if (occ) { track('gift_builder_filter', { filter_type: 'occasion', filter_value: txt(occ) }); return; }
    var mood = t.closest('[data-gsb-mood]');
    if (mood) { track('gift_builder_filter', { filter_type: 'mood', filter_value: txt(mood) }); return; }
    var chip = t.closest('[data-gsb-chip]');
    if (chip) { track('gift_builder_filter', { filter_type: 'type', filter_value: txt(chip) }); return; }
    var rev = t.closest('[data-gsb-review], [data-gsb-review-mobile]');
    if (rev) { track('gift_builder_cta', { cta: 'add_note' }); return; }
    var addcart = t.closest('[data-gsb-addcart]');
    if (addcart) { track('gift_builder_cta', { cta: 'add_box_to_cart' }); return; }
  }, true);

  // 4) Corporate gifting — quote-request submit (KEY conversion for the B2B launch).
  // The native {% form 'contact' %} server-redirects, so fire on submit-intent, deduped.
  // Send ONLY banded/categorical fields — never name/email (PII). The honeypot +
  // native required-field validation gate most spam before this fires.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    if (!form.closest('[data-corp-form]')) return;
    if (form.getAttribute('data-ga-quote-fired')) return;
    form.setAttribute('data-ga-quote-fired', '1');
    var setsEl = form.querySelector('#corp-sets, [name="contact[Sets]"]');
    var occEl = form.querySelector('#corp-occasion, [name="contact[Occasion]"]');
    var sets = setsEl ? parseInt(setsEl.value, 10) : 0;
    var setsBand = !sets ? 'unknown' : sets < 25 ? '1-24' : sets < 100 ? '25-99' : sets < 250 ? '100-249' : '250plus';
    track('corp_bundle_quote_request', {
      corp_occasion: occEl ? (occEl.value || '') : '',
      sets_band: setsBand,
      page_type: templateName()
    });
  }, true);

  // 5) Blog conversion-surface attribution (blog_product_click). A blog article
  // that links to /products/ or /collections/ pages is earning product interest,
  // but a plain internal anchor leaves no GA4 trace and putting utm_ on an internal
  // link is an ANTI-PATTERN — it overwrites the GA4 session source and corrupts
  // attribution. So we fire a dedicated event instead. This is the join between a
  // click and the dashboard's per-element learning: the STABLE cta_id (not ordinal
  // position) is the key. cta_id + placement + link_type vocab is defined once in
  // ~/.claude/skills/monsuri-blog/references/cta-taxonomy.md and must stay identical
  // across the theme, the skill, and the dashboard ingestion.
  //
  // Coverage: inline body links (.art-body) AND the theme-rendered Journal sections
  // (rail / shop-the-ritual / featured / continue), which live OUTSIDE .art-body —
  // so we delegate at document level, guarded to article pages via .art-body.
  // Only runs on article pages. See Documentation/GA4_MEASUREMENT_PLAN.md.
  (function () {
    if (!document.querySelector('.art-body')) return; // not an article page — nothing to bind

    // Parse the destination handle from an internal href (strip query + hash):
    //   /products/<h> or /collections/<h>  → <h>
    //   /blogs/<blog>/<h>                   → <h>  (the article slug)
    function destHandle(href) {
      if (!href) return '';
      var parts = href.split('?')[0].split('#')[0].split('/').filter(Boolean);
      if (parts[0] === 'blogs') return parts[2] || '';
      return parts[1] || ''; // products / collections
    }

    // link_type = the DESTINATION type (controlled vocab: product|collection|blog|'').
    function linkTypeOf(href) {
      if (href.indexOf('/products/') === 0) return 'product';
      if (href.indexOf('/collections/') === 0) return 'collection';
      if (href.indexOf('/blogs/') === 0) return 'blog';
      return '';
    }

    // Fallback cta_id + placement derived from the nearest known section wrapper —
    // used when no explicit data-cta-id is stamped (old articles, or a theme edit
    // that drops the attribute). Degrades to a section-level id, never to null.
    function deriveFromSection(el) {
      var node = el;
      while (node && node !== document.body) {
        if (node.classList) {
          if (node.classList.contains('rail')) return { ctaId: 'rail', placement: 'rail' };
          if (node.classList.contains('m-article-shop-ritual')) return { ctaId: 'bundle', placement: 'bundle' };
          if (node.classList.contains('m-featured-product-section')) return { ctaId: 'featured-section', placement: 'body' };
          if (node.classList.contains('m-continue-section')) {
            if (el.closest && el.closest('.continue-article')) return { ctaId: 'continue-article', placement: 'footer' };
            return { ctaId: 'continue-product', placement: 'footer' };
          }
          if (node.classList.contains('art-body')) return { ctaId: 'inline-body', placement: 'body' };
        }
        node = node.parentNode;
      }
      return { ctaId: 'inline-body', placement: 'body' };
    }

    // Resolve cta_id + placement: explicit on the anchor → nearest [data-cta-id]
    // ancestor (the section wrapper) → deterministic section derivation.
    function resolveCta(anchor) {
      var explicit = anchor.getAttribute('data-cta-id');
      if (explicit) {
        return { ctaId: explicit, placement: anchor.getAttribute('data-placement') || deriveFromSection(anchor).placement };
      }
      var marked = anchor.closest ? anchor.closest('[data-cta-id]') : null;
      if (marked) {
        return { ctaId: marked.getAttribute('data-cta-id'), placement: marked.getAttribute('data-placement') || deriveFromSection(anchor).placement };
      }
      return deriveFromSection(anchor);
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var anchor = t.closest('a[href^="/products/"], a[href^="/collections/"], a[href^="/blogs/"]');
      if (!anchor) return;
      var href = anchor.getAttribute('href') || '';
      var lt = linkTypeOf(href);
      if (!lt) return;
      // Blog→blog links are only a tracked conversion surface when they're a
      // deliberate navigation card (continue-*) or explicitly stamped — not every
      // inline citation in the article prose.
      if (lt === 'blog' && !anchor.getAttribute('data-cta-id') &&
          !(anchor.closest && anchor.closest('.m-continue-section'))) return;
      var cta = resolveCta(anchor);
      track('blog_product_click', {
        blog_handle: window.location.pathname.split('/').filter(Boolean).pop() || '',
        cta_id: cta.ctaId || '',
        placement: cta.placement || '',
        link_type: lt,
        product_handle: destHandle(href)
      });
    }, true); // capture phase — fire before navigation/unload
  })();

})();
